const locale = require('./breadcrumbs.i18n.json');

/*@ngInject*/
const WizardBreadcrumbsController = function ($scope, $stateParams, submissionConstant, breadcrumbsMediator, formViewerConstant, coreConstant, formatUtil) {

    let cachedPromise = null,
        recall = false;

    $scope.i18n = locale;

    $scope.breadcrumbsViewModel = {
        items: [],
        isNarrow: false,
        lastStepCompleted: null,
        loading: false
    };

    let loadBreadcrumbs = function () {
        // if (cachedPromise) {
        //     recall = true;
        //     return;
        // }

        let promise;

        if ($scope.quoteId) {
            promise = breadcrumbsMediator.loadQuoteBreadcrumbs($scope.quoteId);
        } else if ($scope.reportId) {
            promise = breadcrumbsMediator.loadReportBreadcrumbs($scope.reportId);
        } else if ($scope.policyIssuanceId) {
            promise = breadcrumbsMediator.loadPolicyIssuanceBreadcrumbs($scope.policyIssuanceId);
        } else if ($scope.proposalId) {
            promise = breadcrumbsMediator.loadProposalBreadcrumbs($scope.proposalId);
        } else if ($scope.policyCancellationId) {
            promise = breadcrumbsMediator.loadPolicyCancellationBreadcrumbs($scope.policyCancellationId);
        } else if ($scope.endorsementId) {
            promise = breadcrumbsMediator.loadEndorsementBreadcrumbs($scope.endorsementId);
        } else if ($scope.policyRewriteId) {
            promise = breadcrumbsMediator.loadPolicyRewriteBreadcrumbs($scope.policyRewriteId);
        } else if ($scope.policyId) {
            promise = breadcrumbsMediator.loadPolicyBreadcrumbs($scope.policyId);
        } else {
            promise = breadcrumbsMediator.loadSubmissionBreadcrumbs($scope.submissionId);
        }

        promise.then(function (data) {
            $scope.breadcrumbsViewModel.items = _.map(_.cloneDeep(data), function (item) {
                if (item.translateName) {
                    item.name = _.get($scope.i18n, item.name);
                    item.stepCssSelector = formatUtil.formatAsSelector(item.name);
                }

                if ($scope.isItemCompleted(item) || $scope.isItemInProgress(item)) {
                    $scope.breadcrumbsViewModel.lastStepCompleted = item.name;
                }

                return item;
            });
        }).finally(function () {
            $scope.breadcrumbsViewModel.loading = false;

            if (recall) {
                cachedPromise = null;
                recall = false;
                loadBreadcrumbs();
            }
        });
    };

    let reloadBreadcrumbs = function () {
        $scope.breadcrumbsViewModel.loading = true;
        $scope.breadcrumbsViewModel.items = [];
        loadBreadcrumbs();
    };

    let handleScopeChange = function (newValue, oldValue) {
        if (_.isNil(newValue) && _.isNil(oldValue)) {
            return;
        }
        reloadBreadcrumbs();
    };

    $scope.isItemCompleted = function (item) {
        return item.breadCrumbStatus === submissionConstant.breadcrumbsStatus.COMPLETE && !item.earlyEnd;
    };

    $scope.isItemInProgress = function (item) {
        return item.breadCrumbStatus === submissionConstant.breadcrumbsStatus.IN_PROGRESS;
    };

    $scope.isItemEarlyEnd = function (item) {
        return item.earlyEnd && item.breadCrumbStatus !== submissionConstant.breadcrumbsStatus.IN_PROGRESS;
    };

    $scope.$on(submissionConstant.event.REFRESH_BREADCRUMBS, function () {
        loadBreadcrumbs();
    });

    $scope.$on(submissionConstant.event.RELOAD_SUBMISSION, function () {
        loadBreadcrumbs();
    });

    $scope.$on(submissionConstant.event.REFRESH_SUBMISSION, function (event, submission) {
        if (parseInt($stateParams.submissionId) === submission.id) {
            loadBreadcrumbs();
        }
    });

    $scope.$on(coreConstant.event.REFRESH_QUOTE, function (event, submissionId) {
        if (parseInt($stateParams.submissionId) === submissionId) {
            loadBreadcrumbs();
        }
    });

    $scope.onClickFormName = function () {
        $scope.$emit(submissionConstant.event.TOGGLE_NAVIGATION_MENU);
    };

    $scope.$watch('submissionId', handleScopeChange);
    $scope.$watch('quoteId', handleScopeChange);
    $scope.$watch('reportId', handleScopeChange);
    $scope.$watch('policyIssuanceId', handleScopeChange);
    $scope.$watch('proposalId', handleScopeChange);
    $scope.$watch('policyCancellationId', handleScopeChange);
    $scope.$watch('endorsementId', handleScopeChange);
    $scope.$watch('policyId', handleScopeChange);
    $scope.$watch('policyRewriteId', handleScopeChange);
};

angular.module('gw-um-submission')
    .controller('wizardBreadcrumbsController', WizardBreadcrumbsController);
